var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"app-footer d-flex justify-center align-center pa-1"},[_c('v-card-text',{staticClass:"pa-0",staticStyle:{"font-size":"11px"}},[_vm._v("Abriron Cloud Portal v4.9.6 — 2025")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }